import { getFilteredPropertyTypes, language, projectStatuses } from '../constants';
import getLocalizedData from './getLocalizedData';

export const formatRooms = (array, translate, isfullTitle) => {
  const values = array.map(element => ({
    value: typeof element.value === 'number' ? element.value.toString() : element.value,
    label: element.label
  }));

  values.unshift({
    label: `${translate('searchContainer', (isfullTitle) ? 'all_rooms' : 'all')}`,
    value: 'all'
  });

  return values;
};

export const formatTypes = (types, translate, isfullTitle, optionType) => {
  const filtered = getFilteredPropertyTypes(types, optionType);
  const values = filtered.map(element => ({
    value: element,
    label: translate('propertyTypes', element)
  }));

  values.unshift({
    label: `${translate('search_box', 'searchContainer', (isfullTitle) ? 'all_property_types' : 'all')}`,
    value: 'all'
  });

  return values;
};

export const formatAgentSelectOptions = (virtualNumbers, translate) => [
    ...virtualNumbers.map((agent) => ({ label: agent.ext_target_name, value: agent.virtual_number }))
  ];

export const filterVirtualNumbersWithoutStaff = (virtualNumbers, staff) => virtualNumbers.filter(
  (curr) => !staff.find((user) => user.value === curr?.staff_id)
);

export const getAgentSelectOptions = (staff, virtualNumbers, translate) => {
  const allOption = { label: translate('managePage', 'allAgents'), value: 'all' };

  const staffOptions = staff.map((user) => ({
    label: user.label,
    value: `s-${user.value}`
  }));

  const filteredVirtualNumbers = filterVirtualNumbersWithoutStaff(virtualNumbers, staff);
  const virtualOptions = formatAgentSelectOptions(filteredVirtualNumbers, translate);

  return [allOption, ...staffOptions, ...virtualOptions];
};

export const formatOptions = (value, translate) => ({
  label: `${translate('searchContainer', value)}`,
  value,
  selected: false
});

export const formatProjectOptions = (locale, translate, isFullTitle) => {
  const values = projectStatuses.map(item => ({
    value: item.name,
    label: getLocalizedData(item.localisation, locale).result
  }));

  values.unshift({
    label: `${translate('searchContainer', (isFullTitle) ? 'all_statuses' : 'all')}`,
    value: 'all'
  });

  return values;
};
